import type { AreaRoute } from "./areaRoute";
import { Contributors, OperationsPrincipals } from "../../auth/roles";
import { lazyPage } from "../../lib/lazyPage";
const KnowledgeBasePage = lazyPage(() => import("../knowledge/KnowledgeBasePage"), "KnowledgeBasePage");
const KnowledgePostDetailPage = lazyPage(() => import("../knowledge/KnowledgePostDetailPage"), "KnowledgePostDetailPage");
const KnowledgeEditorPage = lazyPage(() => import("../knowledge/KnowledgeEditorPage"), "KnowledgeEditorPage");
const ProceduresPage = lazyPage(() => import("../knowledge/ProceduresPage"), "ProceduresPage");
const ProcedureDetailPage = lazyPage(() => import("../knowledge/ProcedureDetailPage"), "ProcedureDetailPage");
const IncidentsPage = lazyPage(() => import("../hubs/KnowledgePages"), "IncidentsPage");

export { KnowledgeBasePage, ProceduresPage, IncidentsPage };

export const knowledgeRoutes: AreaRoute[] = [
  {
    path: "/knowledge/base/new",
    allow: Contributors,
    element: <KnowledgeEditorPage />
  },
  {
    path: "/knowledge/base/:id",
    allow: OperationsPrincipals,
    element: <KnowledgePostDetailPage />
  },
  {
    path: "/knowledge/base/:id/edit",
    allow: Contributors,
    element: <KnowledgeEditorPage />
  },
  {
    path: "/knowledge/procedures/:id",
    allow: OperationsPrincipals,
    element: <ProcedureDetailPage />
  }
];
